/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Email_RequiredInputs */

const en_mobile_email_required = /** @type {(inputs: Mobile_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please, enter your email address`)
};

const es_mobile_email_required = /** @type {(inputs: Mobile_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa tu correo electrónico`)
};

/**
* | output |
* | --- |
* | "Please, enter your email address" |
*
* @param {Mobile_Email_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_email_required = /** @type {((inputs?: Mobile_Email_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Email_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_email_required(inputs)
	return en_mobile_email_required(inputs)
});